import React, { useState, useEffect } from "react";
import axios from "axios";
import { setGlobalVariable } from "../shared";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import customLinkForLIONReource from "./customLinkForLIONReource";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";

function AcceleratedLearning({
  acceleratedLearningData,
  loadingResults,
  activeTab,
  baseUrl,
}) {
  const [intValue, setIntValue] = useState(null);

  const [columnDefs] = useState([
    { headerName: "Subject", field: "Subject", filter: true,
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130,sort:'asc' },
      
    { headerName: "TIA Teacher", field: "Teachers_TIA", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      flex: 1, minWidth: 150 },

    { headerName: "Period", field: "ClassId", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },

    { headerName: "AI Time", field: "AI_Time", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },

    { headerName: "Test", field: "STAAR_Test", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },

    { headerName: "Title", field: "STAAR_Title", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "start" }, flex: 3, minWidth: 250 },

    { headerName: "Scale Score", field: "STAAR_ScaleScore", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },

    { headerName: "%", field: "STAAR_Score", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },

    { headerName: "Raw Score", field: "STAAR_RawScore", filter: true, 
      filterParams: {
        buttons: ["reset", "cancel"],
        closeOnApply: true,
      },
      cellStyle: { textAlign: "center" }, flex: 1, minWidth: 130 },
  ]);

  useEffect(() => {
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      "Content-Type": "application/json", // Optional: Define the content type if needed
    };
    if (token != null) {
      axios
        .get(
          baseUrl +
          `Student/GetHelpPageId?studentkey=${studentkey}&districtId=${districtID}&url=${activeTab}`,
          { headers }
        )
        .then((response) => {
          console.log(response);
          const fetchedValue = response.data;
          setIntValue(fetchedValue);
          setGlobalVariable(fetchedValue);
          console.log("Fetched intValue:", fetchedValue);
        })
        .catch((error) => {
          console.error("Error fetching intValue:", error);
        });
    }
  }, []);

  if (loadingResults) {
    return <div>Loading...</div>;
  }

  let result = [];

  acceleratedLearningData.map((item) => {
    if (!item.hide) {
      result.push(item);
    }
  });

  const isAnyTrue = result.some((obj) => {
    // Check if any value in the object is true
    return Object.values(obj).includes(false);
  });

  const gridOptions = {
    icons: {
      sortAscending: '<span class="ag-icon ag-icon-desc">▲</span>',
      sortDescending: '<span class="ag-icon ag-icon-asc">▼</span>',
    },
  };
  return (
    <div className="accelerated-learning">
      {/* <h2>Accelerated Learning</h2> */}
      {isAnyTrue && result.length > 0 ? (
        <div className="ag-theme-alpine" style={{ height: "400px" }}>
          <AgGridReact
            gridOptions={gridOptions}
            rowData={result}
            columnDefs={columnDefs}
            domLayout="autoHeight"
            suppressScrollOnNewData={true}
          />
        </div>
      ) : (
        <div style={{textAlign:"center", marginTop:"10%"}}>
        <h3>No data available</h3>
      </div>
      )}
    </div>
  );
}

export default AcceleratedLearning;
